/*
 * NOTE: We want to maintain this component level template as .ts file so we can add comments.
 */

export default {
  name: 'dashify:HealthPie',
  title: 'HealthPie',
  owner: 'System',
  solution: '',
  tags: ['data', 'visualization', 'pie', 'donut'],
  createdAt: 'Aug 21, 2023, 10:14 AM',
  updatedAt: 'Oct 12, 2023, 09:03 AM',
  spec: {
    props: {
      highchartsConfig: {},
    },
    defaults: {
      series: [],
      height: '160',
      chart: {
        type: 'pie',
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        backgroundColor: 'rgba(0,0,0,0)',
        styledMode: false,
      },
      title: {
        verticalAlign: 'middle',
        widthAdjust: -80,
        style: {
          color: '#B1B2B3',
          fontSize: 28,
          lineHeight: 33,
          weight: 500,
        },
      },
      subtitle: {
        verticalAlign: 'middle',
        widthAdjust: -80,
        y: 40,
        style: {
          color: '#B1B2B3',
          fontSize: 16,
          lineHeight: 19,
          weight: 500,
        },
      },
      plotOptions: {
        pie: {
          // need the color arrays here to enforce the color overwrite on top of the color index passed in through series data array
          colors: ['#FA5762', '#F0C243', '#C4C4C4', '#4CBF7F'],
          // below following https://api.highcharts.com/highcharts/plotOptions.pie.borderWidth
          // in hope to get rid of the white border around slices but did not work
          borderColor: null,
          borderWidth: 0.5,
          size: 160,
          allowPointSelect: true,
          cursor: 'pointer',
          innerSize: '56.25%',
          crisp: true,
          dataLabels: {
            shadow: false,
            connectorShape: 'straight',
            enabled: true,
            format: "<div style='font-weight: 400'>{point.name}</div>: <div style='font-weight: 500'>{point.y}</div>",
            style: {
              fontSize: 13,
              lineHeight: 15,
              color: '#B1B2B3',
              // below needed as default without styleMode applies stroke on text
              textOutline: 0,
              fontFamily: 'var(--typography-font-body)',
            },
            y: -5,
          },
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        useHTML: true,
        formatter: function (this: any) {
          // svg tooltip not enabled in this iteration: https://github.com/highcharts/highcharts/issues/15031
          // we will need to add src to allowed attribute in highchart module since this security improvement since V9.0.0
          return (
            "<div style='width: 130px; height: 42px; border-radius: 6px; padding: 12px; display: flex; background-color: #373C42; color: #FFFFFF; line-height: 18px; align-items: center;'><span style='padding-left: 8px; font-size: 11px; line-height: 13px;'>" +
            this.point.name +
            "</span><span style='margin-left: auto; font-size: 11px; line-height: 13px;'>" +
            this.point.y +
            '</span></div>'
          );
        },
        padding: 0,
        borderWidth: 0,
        borderRadius: 6,
      },
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
    },
    view: [
      [
        'div',
        {
          '.': 'grow',
        },
        [['dashify:Highcharts', '/${ $defaultsDeep({}, props, props.highchartsConfig, defaults) }']],
      ],
    ],
  },
};
